import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { customElement as n } from '../../../../node_modules/@lit/reactive-element/decorators/custom-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './page-header.scss.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';

let PageHeader = class PageHeader extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.buttons = 1;
        this.isPriority = false;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.isPriority) {
            this.addEventListener('DOMContentLoaded', this.preloadImage.bind(this));
        }
    }
    preloadImage() {
        var _a;
        const mainImageSlot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot[name="main-image"]');
        if (mainImageSlot) {
            const assignedElements = mainImageSlot.assignedElements();
            if (assignedElements.length > 0) {
                const imageElement = assignedElements[0];
                const bgImage = imageElement.style.backgroundImage;
                if (bgImage) {
                    const imageUrl = bgImage.replace(/url\(['"]?(.+?)['"]?\)/, '$1');
                    if (imageUrl && !document.querySelector(`link[rel="preload"][href="${imageUrl}"]`)) {
                        const preloadLink = document.createElement('link');
                        preloadLink.rel = 'preload';
                        preloadLink.as = 'image';
                        preloadLink.href = imageUrl;
                        preloadLink.setAttribute('fetchpriority', 'high');
                        document.head.appendChild(preloadLink);
                    }
                }
            }
        }
    }
    render() {
        return $ `<div class="page-header-container" dir="${this.rtl || isRTL() ? 'rtl' : 'ltr'}"><div class="page-header"><slot name="main-image"></slot></div><div class="page-header__content-box page-header__content-box${this.rtl
            ? '--rtl'
            : '--ltr'}"><div class="page-header__text-container"><slot name="eyebrow-content"></slot><slot name="title-content" id="title"></slot><slot name="main-text" id="description"></slot></div><slot name="cta" id="cta"></slot></div></div>`;
    }
};
PageHeader.styles = css_248z;
__decorate([
    e({ type: Boolean })
], PageHeader.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], PageHeader.prototype, "eyebrow", void 0);
__decorate([
    e({ type: Number })
], PageHeader.prototype, "buttons", void 0);
__decorate([
    e({ type: String })
], PageHeader.prototype, "componentId", void 0);
__decorate([
    e({ type: Boolean })
], PageHeader.prototype, "isPriority", void 0);
PageHeader = __decorate([
    n('page-header')
], PageHeader);

export { PageHeader };
